(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.re-reveal:not(.re-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('re-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('re-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initDestellos() {
    document.querySelectorAll('[data-re-destellos]').forEach(function (c) {
      if (c.dataset.listo) return;
      c.dataset.listo = '1';
      var n = parseInt(c.dataset.reDestellos, 10) || 0;
      for (var i = 0; i < n; i++) {
        var s = document.createElement('span');
        s.className = 're-destello';
        var size = 2 + Math.random() * 5;
        s.style.cssText = 'left:' + (Math.random() * 100) + '%;top:' + (Math.random() * 100) + '%;--s:' + size + 'px;--d:' + (3 + Math.random() * 5) + 's;--dl:' + (-Math.random() * 6) + 's;--o:' + (0.45 + Math.random() * 0.55);
        c.appendChild(s);
      }
    });
  }

  function initTilt() {
    if (window.matchMedia('(hover: none)').matches || reduce) return;
    document.querySelectorAll('[data-re-tilt]').forEach(function (card) {
      if (card.dataset.tiltListo) return;
      card.dataset.tiltListo = '1';
      var fuerza = parseFloat(card.dataset.reTilt) || 6;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--ry', (x * fuerza) + 'deg');
        card.style.setProperty('--rx', (-y * fuerza) + 'deg');
      });
      card.addEventListener('mouseleave', function () { card.style.setProperty('--ry', '0deg'); card.style.setProperty('--rx', '0deg'); });
    });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-re-parallax]');
    if (!imgs.length || reduce) return;
    var tick = false;
    function upd() {
      imgs.forEach(function (img) {
        var k = parseFloat(img.dataset.reParallax) || 0;
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        img.style.translate = '0 ' + (-r.top * k / 100).toFixed(1) + 'px';
      });
      tick = false;
    }
    window.addEventListener('scroll', function () { if (!tick) { requestAnimationFrame(upd); tick = true; } }, { passive: true });
    upd();
  }

  function initCuenta() {
    document.querySelectorAll('[data-re-cuenta]').forEach(function (el) {
      if (el.dataset.listo) return;
      el.dataset.listo = '1';
      var fin = new Date(el.dataset.fin).getTime();
      if (isNaN(fin)) return;
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      var t;
      function tick() {
        var r = fin - Date.now();
        if (r <= 0) { el.hidden = true; if (t) clearInterval(t); return; }
        el.hidden = false;
        var sec = Math.floor(r / 1000);
        d.textContent = pad(Math.floor(sec / 86400));
        h.textContent = pad(Math.floor((sec % 86400) / 3600));
        m.textContent = pad(Math.floor((sec % 3600) / 60));
        s.textContent = pad(sec % 60);
      }
      tick();
      t = setInterval(tick, 1000);
    });
  }

  function initProducto() {
    document.querySelectorAll('[data-re-producto]').forEach(function (root) {
      if (root.dataset.listo) return;
      root.dataset.listo = '1';
      var principal = root.querySelector('[data-re-principal]');
      var minis = root.querySelectorAll('[data-re-miniatura]');
      minis.forEach(function (b) {
        b.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = 0;
          setTimeout(function () { principal.removeAttribute('srcset'); principal.src = b.dataset.full; principal.alt = b.dataset.alt || ''; principal.style.opacity = 1; }, 180);
          minis.forEach(function (x) { x.classList.remove('is-activa'); });
          b.classList.add('is-activa');
        });
      });
      var qty = root.querySelector('[data-re-cantidad] input');
      var menos = root.querySelector('[data-re-menos]');
      var mas = root.querySelector('[data-re-mas]');
      if (qty && menos) menos.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (qty && mas) mas.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

      var jsonEl = root.querySelector('[data-re-variantes]');
      var grupos = Array.prototype.slice.call(root.querySelectorAll('[data-re-opcion]'));
      if (!jsonEl || !grupos.length) return;
      var variantes = JSON.parse(jsonEl.textContent);
      var input = root.querySelector('input[name="id"]');
      var btn = root.querySelector('[data-re-comprar]');
      var pAct = root.querySelector('[data-re-precio]');
      var pAnt = root.querySelector('[data-re-precio-antes]');
      var ahorro = root.querySelector('[data-re-ahorro]');
      var moneda = root.dataset.moneda || 'EUR';
      function money(c) { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: moneda }).format(c / 100); }
      grupos.forEach(function (g) {
        g.querySelectorAll('[data-re-valor]').forEach(function (b) {
          b.addEventListener('click', function () {
            g.querySelectorAll('[data-re-valor]').forEach(function (x) { x.classList.remove('is-activo'); });
            b.classList.add('is-activo');
            var sel = grupos.map(function (gr) { var a = gr.querySelector('.is-activo'); return a ? a.dataset.reValor : null; });
            var v = variantes.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
            if (!v) { btn.disabled = true; btn.textContent = btn.dataset.agotado; return; }
            input.value = v.id;
            if (pAct) pAct.textContent = money(v.price);
            var rebaja = v.compare_at_price > v.price;
            if (pAnt) { pAnt.hidden = !rebaja; if (rebaja) pAnt.textContent = money(v.compare_at_price); }
            if (ahorro) { ahorro.hidden = !rebaja; if (rebaja) ahorro.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
            var p1 = root.querySelector('[data-re-pack1]');
            var p2 = root.querySelector('[data-re-pack2]');
            var packs = root.querySelector('[data-re-packs]');
            if (p1) p1.innerHTML = money(v.price) + (rebaja ? '<s>' + money(v.compare_at_price) + '</s>' : '');
            var desc = packs ? parseInt(packs.dataset.reDescuento || '0', 10) : 0;
            if (p2 && desc > 0) {
              var precio2 = v.price * 2 - desc;
              var antes2 = rebaja ? v.compare_at_price * 2 : v.price * 2;
              p2.innerHTML = money(precio2) + (antes2 > precio2 ? '<s>' + money(antes2) + '</s>' : '');
            }
            btn.disabled = !v.available;
            btn.textContent = v.available ? btn.dataset.disponible : btn.dataset.agotado;
            var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState(null, '', u);
          });
        });
      });
    });
  }

  function init() { initReveal(); initDestellos(); initTilt(); initParallax(); initCuenta(); initProducto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initReveal(); initDestellos(); initTilt(); initCuenta(); initProducto(); });
})();
